export default "__VITE_ASSET__CKnsSMSs__"